export const PDF_CLAIMS_UPLOAD_ENABLED_RESELLERS: string[] = [
    '32570', // BEST BUY (US)
];
